<template lang="html">
  <div>
    <van-nav-bar
      :title="title"
      left-text=""
      right-text=""
    />
    <EpisodeList
      :slug="slug"
      :editorChoiceOnly="false"
      :publicOnly="true"
      :limit="0"
      @got-episodes-count="gotEpisodesCount"
    />
  </div>
</template>

<script>
  import EpisodeList from './episode-list.vue'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)
  export default {
    name: "PublicEpisodes",
    components: {
      EpisodeList
    },
    data () {
      return {
        slug: '', // show 的 slug
        title: '公播节目'
      }
    },
    methods: {
      gotEpisodesCount (count) {
        this.title = `${this.title} ${count} 期`
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
